module.exports = require('./OrderTabsComponent');